module.exports = __webpack_public_path__ + "img/laflorida_background_hero.0a204189.png";